// @ts-nocheck
import { StyledClickable } from "@insite/mobius/Link";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { linkStyles } from "@store/Themes/common/mixins/link";
import breakpointValues, { BreakpointValue } from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { Amount } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { spacingStyles } from "@toolkit/Themes/common/mixins";
/* Store Custom Code - End */

export const inlineSeparatorStyles = (options?: {
    color?: string;
    height?: string;
    side?: "left" | "right";
    spacing?: string;
    spacingType?: "margin" | "padding";
    width?: string;
}) => {
    const {
        color = "common.border",
        height = "1em",
        side = "right",
        spacing = "1em",
        spacingType = "margin",
        width = "1px",
    } = options || {};

    const sideSelector = side === "right" ? "&:last-child" : "&:first-child";

    return css`
        position: relative;
        ${spacingType}-${side}: calc(${spacing} + ${width});

        &::after {
            content: "";
            position: absolute;
            ${side}: ${spacingType === "padding" ? `calc(${spacing} / 2)` : `calc((-${spacing} / 2) - ${width})`};
            height: ${height};
            width: ${width};
            background-color: ${getColor(color)};
            top: 50%;
            transform: translateY(-50%);
            pointer-events: none;
        }

        ${sideSelector} {
            ${spacingType}-${side}: 0;

            &::after {
                display: none;
            }
        }
    `;
};

export const lineEllipsisStyles = (lineClamp: number) => {
    return css`
        /* stylelint-disable value-no-vendor-prefix, property-no-vendor-prefix */
        display: -webkit-box;
        overflow: hidden;
        -webkit-line-clamp: ${lineClamp};
        -webkit-box-orient: vertical;
        /* stylelint-enable value-no-vendor-prefix, property-no-vendor-prefix */
    `;
};

export const loadingDotsStyles = () => {
    return css`
        display: inline-block;
        text-align: left;
        font-weight: ${x => x.theme.design.typography.weight.bold};
        min-width: 25px;

        &::after {
            overflow: hidden;
            display: inline-block;
            vertical-align: bottom;
            animation: loadingDots steps(4, end) 900ms infinite 1s;
            content: "\\2026";
            width: 0;
        }
    `;
};

export const loadingDotsKeyFrames = () => {
    return css`
        @keyframes loadingDots {
            to {
                width: 1.25em;
            }
        }
    `;
};

export const typographyInvertColorStyles = (
    color = "invert",
    hoverColor: string | null = "invert.dark",
    underline = true,
    hoverUnderline = true,
) => {
    return css`
        color: ${getColor(color)};

        ${TypographyStyle}:not(.formField) {
            color: inherit;
        }

        ${StyledClickable} {
            ${linkStyles("inherit", hoverColor, underline, hoverUnderline)}
        }
    `;
};

export const typographyTitleStyles = (fontSizes?: BreakpointValue<Amount>[]) => {
    return css`
        ${breakpointValues(fontSizes, "font-size")}
        ${({ theme }) => `
            font-family: ${theme.design.typography.fontFamily.title};
            font-weight: ${theme.design.typography.weight.bold};
        `}
    `;
};

export const typographyProductNameStyles = () => {
    return css`
        ${({ theme }) => css`
            font-size: ${theme.design.typography.size.large};
            font-weight: ${theme.design.typography.weight.bold};
            line-height: 1.33;
        `}
    `;
};

/* Store Custom Code - Start */
export const titleStyles = () => {
    return css`
        ${spacingStyles("1em", "0.5em")}
        ${({ theme }) => `
            font-weight: ${theme.design.typography.weight.bold};
            font-family: ${theme.design.typography.fontFamily.title};
            line-height: ${theme.design.typography.lineHeight.small};
            color: ${theme.colors.primary.main};
        `}
    `;
};
/* Store Custom Code - End */
